import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import bRoot from "./components/clon/beRoot";
import VueCookies from "vue-cookies";
import moment from "moment-timezone";

Vue.config.productionTip = false;
let eventHub = new Vue();
moment.tz.setDefault("America/Argentina/Buenos_Aires");
Vue.prototype.$bRoot = new bRoot(eventHub, moment);
Vue.prototype.$MyAppName = "Clon Web";
Vue.use(VueCookies);
Vue.prototype.$moment = moment;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
